import { ArrowSquareOut } from "@phosphor-icons/react";

/**
 * OpenInTabLink — small inline icon that always opens `to` in a new tab.
 * Use it next to a record name/title so users have an explicit "open in new tab"
 * affordance. Native browser behaviour (right-click / middle-click / Ctrl+click)
 * also works because this is a real <a> element with `target="_blank"`.
 */
export default function OpenInTabLink({ to, title = "Open in new tab", testId, size = 13 }) {
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      title={title}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center text-slate-400 hover:text-[#002FA7] transition-colors ml-1.5"
    >
      <ArrowSquareOut size={size} weight="bold" />
    </a>
  );
}
